module.exports = __webpack_public_path__ + "media/images/iconBell__okGreen--dark-e96d9e1d9088dc9b06acc4493763f804.png";